export default "__VITE_ASSET__978e1945__"